import { InjectionToken } from "@angular/core";

export const ROOM_APP_URL = new InjectionToken<string>("ROOM_APP_URL");
export const ROOM_SIGN_IN_URL = new InjectionToken<string>("ROOM_SIGN_IN_URL");
export const ROOM_STUDIO_URL = new InjectionToken<string>("ROOM_STUDIO_URL");
